/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import { Outlet } from "react-router";
import AuthDialogProvider from "@/src/provider/AuthDialog/AuthDialogProvider";

export default function PublicRoutes() {
  return (
    <>
      <AuthDialogProvider>
        <Outlet />
      </AuthDialogProvider>
    </>
  );
}
